export default __webpack_public_path__ + "static/timeline0-21df49492edad4ba7b00d6702695231a.png";